import { render, staticRenderFns } from "./langs.vue?vue&type=template&id=69a0d278"
import script from "./langs.vue?vue&type=script&lang=js"
export * from "./langs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports